<template>
    <div class="container">
        <div class="row">
            <div class="col-md-6">
                <h2>Search</h2>  
            </div>
            <div class="col-md-6 text-right">
                <div class="btn btn-secondary btn-sm" @click.prevent="print">Print Page</div>
            </div>
        </div>
        <div class="row">

            <div class="col-md-12 pt-4">
                <form novalidate @submit.prevent="submit">
                    <div class="row">
                        <div class="col-md-4">
                            <h4>Force & Area</h4>
                            <div class="form-group">
                                <label for="force_id" class="">Forces</label>             
                                <select class="custom-select " :class="{'is-invalid': forceHasError}" id="force_id" name="force_id" required="required" 
                                    v-model="params.force_id"
                                    :disabled="loading">
                                    <option value="">--- ALL Forces ---</option>
                                    <option v-for="force in forces" :key="force.id" :value="force.id">
                                        {{ force.name }}
                                    </option>
                                </select>
                                <form-error name="force_id" :errors="errors"></form-error>
                            </div>
        
                            <div class="form-group">
                                <label for="lpa_ids" class="">LPAs</label>
                                <multiselect placeholder="Select LPAs"
                                    v-model="lpasSelected"
                                    :options="lpas" 
                                    :limit="3"
                                    :limit-text="categoryLimitText"
                                    :disabled="! lpas.length || loading"
                                    track-by="id" 
                                    label="name"
                                    :closeOnSelect="false"
                                    :multiple="true" 
                                    :hideSelected="true" />
                                <form-error name="lpa_ids" :errors="errors"></form-error>
                            </div>                    
                        </div>

                        <div class="col-md-4">
                            <h4>Type / Categories</h4>
                            <div class="form-group">
                                <label for="type_id" class="">Retailer Type</label>             
                                <select class="custom-select " :class="{'is-invalid': typeHasError}" id="type" name="type_id" required="required" 
                                    v-model="params.type_id"
                                    :disabled="loading">
                                    <option value="">--- ALL Types ---</option>
                                    <option v-for="type in types" :key="type.id" :value="type.id">
                                        {{ type.name }}
                                    </option>
                                </select>
                                <form-error name="type_id" :errors="errors"></form-error>
                            </div>
                            <div class="form-group">
                                <label for="category_ids" class="">Categories</label>
                                <multiselect v-model="categoriesSelected" 
                                    placeholder="Select Categories" 
                                    :options="categories" 
                                    :limit="3" 
                                    :limit-text="categoryLimitText" 
                                    label="name" track-by="id" 
                                    :multiple="true" 
                                    :hideSelected="true"
                                    :closeOnSelect="false"
                                    :disabled="loading" />
                                <form-error name="category_ids" :errors="errors"></form-error>
                            </div> 
                        </div>

                        <div class="col-md-4">
                            <h4>Other</h4>
                            <div class="form-group row mb-0 mt-8">
                                <label for="wdbcSeachOption" class="col-4">WDBC</label> 
                                <div class="col-8">
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="radio" name="wdbcSeachOption" id="wdbcSeachOption1" value="yes" v-model="params.wdbc" :disabled="loading">
                                        <label class="form-check-label" for="wdbcSeachOption1">Yes</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="radio" name="wdbcSeachOption" id="wdbcSeachOption2" value="no" v-model="params.wdbc" :disabled="loading">
                                        <label class="form-check-label" for="wdbcSeachOption2">No</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="radio" name="wdbcSeachOption" id="wdbcSeachOption3" value="" v-model="params.wdbc" :disabled="loading" >
                                        <label class="form-check-label" for="wdbcSeachOption3">Both</label>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="cctvSearchOption" class="col-4">CCTV</label> 
                                <div class="col-8">
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="radio" name="cctvSearchOption" id="cctvSearchOption1" value="yes" v-model="params.cctv" :disabled="loading">
                                        <label class="form-check-label" for="cctvSearchOption1">Yes</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="radio" name="cctvSearchOption" id="cctvSearchOption2" value="no" v-model="params.cctv" :disabled="loading">
                                        <label class="form-check-label" for="cctvSearchOption2">No</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="radio" name="cctvSearchOption" id="cctvSearchOption3" value="" v-model="params.cctv" :disabled="loading">
                                        <label class="form-check-label" for="cctvSearchOption3">Both</label>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="visitFrom" class="col-sm-4 col-form-label">Visit From</label>
                                <div class="col-sm-8">
                                    <flat-pickr id="visitFrom"
                                        class="form-control " :class="{'is-invalid':fromHasError}" 
                                        v-model="params.from"
                                        :config="dateConfig"
                                        :disabled="loading">
                                    </flat-pickr>
                                </div>
                                <form-error name="from" :errors="errors"></form-error>
                            </div>

                            <div class="form-group row">
                                <label for="visitTo" class="col-sm-4 col-form-label">Visit To</label>
                                <div class="col-sm-8">
                                    <flat-pickr id="visitTo"
                                        class="form-control " :class="{'is-invalid':toHasError}" 
                                        v-model="params.to"
                                        :config="dateConfig"
                                        :disabled="loading">
                                    </flat-pickr>
                                </div>
                                <form-error name="to" :errors="errors"></form-error>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <button type="submit" class="btn btn-secondary" :disabled="loading">
                                Search
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span>
                            </button>
                            <button @click.prevent="reset" class="btn btn-link ml-3" :disabled="loading">Clear</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <div class="row justify-content-center mt-4">
            <table class="table table-responsive-md">
                <thead>
                    <tr><th scope="col">Name</th> <th scope="col">Email</th> <th scope="col">WDBC Sign Up</th> <th scope="col">Signs Displayed</th> <th  scope="col">CCTV</th> <th scope="col">Visits</th> <th scope="col">Neighbourhood</th> <th scope="col">LPA</th><th class="actions-col"></th></tr>
                </thead> 
                <tbody>
                    <tr v-for="result in results" :key="result.id">
                        <td >{{result.retailer_name}}</td>
                        <td v-if="result.retailer_email">{{result.retailer_email}}</td>
                        <td v-else>
                            <div class="btn btn-default py-0 px-1" v-tooltip="'Missing Email'">
                                <img src="../../../assets/svgs/Warning-Icon.svg">
                            </div>
                        </td>
                        <td >{{result.wdbc ? 'Yes':'No'}}</td>
                        <td >{{result.signs}}</td>
                        <td >{{result.cctv ? 'Yes':'No'}}</td>
                        <td >{{result.visits_count}}</td>
                        <td >{{result.neighbourhood.name}}</td>
                        <td >{{result.lpa.name}}</td>
                        <td class="actions-col">
                            <router-link :to="{name: 'retailers.edit', params:{id: result.id}}" class="btn btn-default py-0 px-1" v-tooltip="'Edit'">
                                <img src="../../../assets/svgs/Edit-Icon.svg">
                            </router-link>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="8" class="text-center" v-if="results.length == 0">No Results Found</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="row">
            <router-link :to="{name:'search.email', query:{bcc:sendTo}}" class="btn btn-secondary" v-if="results.length != 0">Email All Retailers</router-link>
        </div>
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import FormError from "../../Util/FormError";
import "vue-multiselect/dist/vue-multiselect.min.css";
import SearchService from "../../../services/SearchService";
import CurrentUser from "../../../mixins/CurrentUser";
import FlatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
    data() {
        return {
            loadingParams: false,
            params: {
                force_id: '',
                type_id: 1,
                lpa_ids: [],
                category_ids: [],
                wdbc: '',
                cctv: '',
                from: '',
                to: '',
            },
            categoriesSelected: [],
            lpasSelected: [],
            errors: {},
            results: [],
            loading: false,
            dateConfig: {
                altInput: true,
                dateFormat: 'Y-m-d',
                altFormat: "d/m/Y"
            }
        }
    },

    mixins: [CurrentUser],

    components: {Multiselect, FormError, FlatPickr},

    mounted(){
        this.$store.dispatch('productcategories/load');
        this.$store.dispatch('lpas/load');
        this.$store.dispatch('retailertypes/load');

        if (window._.isEmpty(this.$route.query)) {
            let now = new Date();
            this.params.to = now.toISOString().split('T')[0];
            now.setMonth(now.getMonth()-1);
            this.params.from = now.toISOString().split('T')[0];
            this.params.force_id = this.currentUser.force_id;
        } else {
            this.loadingParams = true;
            this.params = {...this.params, ...this.$route.query};

            if (! window._.isEmpty(this.params.category_ids) && ! window._.isArray(this.params.category_ids)) {
                this.params.category_ids = [parseInt(this.params.category_ids)];
            }

            if (! window._.isEmpty(this.params.lpa_ids) && ! window._.isArray(this.params.lpa_ids)) {
                this.params.lpa_ids = [parseInt(this.params.lpa_ids)];
            }

            this.params.force_id = this.params.force_id != "" ? parseInt(this.params.force_id) : "";
            this.params.type_id = this.params.type_id != "" ? parseInt(this.params.type_id) : "";

            if (! this.$store.state.productcategories.loaded) {
                setTimeout(this.loadStateFromQuery, 700);
                return;
            }
            this.loadStateFromQuery();
        }
    },

    watch: {
        force_id: function () {
            if (!this.loadingParams) {
                this.lpasSelected = [];
            }
        },
        category_ids: function () {
            if (!this.loadingParams) {
                this.params.category_ids = this.category_ids;
            }
        },
        lpa_ids: function () {
            if (!this.loadingParams) {
                this.params.lpa_ids = this.lpa_ids;
            }
        }
    },

    methods:{
        print: function () {
            window.print();
        },
        submit: function () {
            this.loading = true;
            this.$router.push({name: 'search.index', query: this.params}).catch(()=>{});

            SearchService.search(this.params)
                .then(({data}) => this.success(data))
                .catch();
        },
        success: function (data) {
            this.results = data.data;
            this.loading = false;
        },
        failed: function () {
            this.loading = false;
            window.flash('An Error occurred. Please try again.', 'danger');
        },
        reset: function () {
            this.params = {
                force_id: '',
                type_id: 1,
                lpa_ids: [],
                category_ids: [],
                wdbc: '',
                cctv: '',
                from: '',
                to: '',
            }
            this.lpasSelected = this.categoriesSelected = [];
        },
        categoryLimitText (count) {
            return `and ${count} other categories`
        },
        clearCategoriesAll () {
            this.categoriesSelected = []
        },
        hasError: function (key) {
            return (this.errors[key]);
        },

        convertCategoryIdsToCategories: function (categoryIds) {
            let selected = [];
            const _ = window._;

            if ( _.isEmpty(categoryIds)) {
                return selected;
            }

            if (! _.isEmpty(categoryIds) && ! _.isArray(categoryIds)) {
                categoryIds = [parseInt(categoryIds)];
            }

            categoryIds.forEach(id => {
                const category = this.categories.find(category => category.id == parseInt(id));
                if(category != undefined) {
                    selected.push(category);
                }
            });
            return selected;
        },

        convertLpaIdsToLpas: function (lpaIds) {
            const _ = window._;
            let selected = [];

            if (_.isEmpty(lpaIds)) {
                return selected;
            }

            if (! _.isEmpty(lpaIds) && ! _.isArray(lpaIds)) {
                lpaIds = [parseInt(lpaIds)];
            }

            lpaIds.forEach(id => {
                const lpa = this.$store.state.lpas.data.find(lpa => lpa.id == parseInt(id));
                if(lpa != undefined) {
                    selected.push(lpa);
                }
            });
            return selected;
        },

        loadStateFromQuery: function () {
            if( this.$store.state.productcategories.loaded && this.$store.state.lpas.loaded) {
                this.categoriesSelected = this.convertCategoryIdsToCategories(this.params.category_ids);
                this.lpasSelected = this.convertLpaIdsToLpas(this.$route.query.lpa_ids);
            }
            this.$nextTick(() => {
                this.loadingParams = false;
                this.submit();
            });
        }
    },

    computed:{
        force_id: function () {
            return this.params.force_id;
        },
        forces: function () {
            return this.$store.state.forces.data;
        },
        categories: function () {
            return this.$store.state.productcategories.data;
        },
        types: function () {
            return this.$store.state.retailertypes.data;
        },
        lpas: function () {
            if (this.force_id === '') {
                return [];
            }

            return this.$store.state.lpas.data.filter(lpa => lpa.force_id === this.force_id);  
        },
        category_ids: function () {
            return this.categoriesSelected.map( cat => cat.id );
        },
        lpa_ids: function () {
            return this.lpasSelected.map( lpa => lpa.id );
        },
        sendTo: function () {
            return this.results.map( retailer => retailer.retailer_email)
                .filter(email => email != '' && email != null)
                    .join(';');
        },

        forceHasError: function () { return this.hasError('force_id') },
        LpaHasError: function () { return this.hasError('lpa_ids') },
        typeHasError: function () { return this.hasError('type_id') },
        fromHasError: function () { return this.hasError('from') },
        toHasError: function () { return this.hasError('to') },
        categoriesHasError: function () { return this.hasError('category_ids') },
    }
}
</script>